export default __webpack_public_path__ + "static/media/cloud.47f081f7.svg";